import { PLATFORMS, type Platform } from "@/types/platform.types";
import { ROLES } from "@/constants/roles";

/**
 * Which platforms each role may access. Admin spans admin/fleet/driver.
 */
export const ROLE_PLATFORM_MAP = {
	[ROLES.ADMIN]: [PLATFORMS.ADMIN, PLATFORMS.FLEET, PLATFORMS.DRIVER],
	[ROLES.FLEET_MANAGER]: [PLATFORMS.FLEET],
	[ROLES.DRIVER]: [PLATFORMS.DRIVER],
} as const;

/**
 * Resolve the platforms a user with the given roles may access. Order follows
 * `ROLE_PLATFORM_MAP` insertion order, so `[0]` is the natural default
 * landing platform.
 */
export function getAvailablePlatformsForRoles(
	roles: ReadonlyArray<string>
): Array<Platform> {
	const uniquePlatforms = new Set<Platform>();

	Object.entries(ROLE_PLATFORM_MAP).forEach(([role, platforms]) => {
		if (roles.includes(role)) {
			platforms.forEach((platform) => uniquePlatforms.add(platform));
		}
	});

	return Array.from(uniquePlatforms);
}
